export enum GeneralPageEnum {
  PREFERENCES = "Preferences",
  CURRENCIES = "Currencies",
  LANGUAGES = "Languages",
  MEASUREMENTS = "Measurements",
  ORDER_TYPE = "Order Type",
  LEAD_SOURCE = "Lead Source",
  OPERATIONS_APP = "Operations app",
  STATUS = "Statuses",
  TASK_TYPE = "Tasks Type",
  SSCC_GENERATION = "SSCC Generation",
  TOLERANCE_PORCENTAGE = "Tolerance Percentage",
  CARRIERS = "Carriers",
  BRANDS = "Brands",
  NETWORK = "Network",
  MILITARY = "Military",
}
